import { Progress, ProgressProps } from '@makyoapp/makyo-tw-ui'

export const CompLinearProgressCore = Progress
export type CompLinearProgressProps = ProgressProps
